webpackJsonp([114276838955818,60335399758886],{

/***/ 93:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(154);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(93);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 676:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAABUCAMAAABZeoJFAAAAmVBMVEX///9dZILq6+9rcYxgZ4Xk5eqZnrBwd5BudI7Y2uCjp7i4u8h4fpby8/Xn6Oz6+vtlbIdzeZP+/v719viJjqOGi6H4+fq8v8ynqrvq6+7f4eafo7Vob4rt7vF7gZl5f5f8/P3j5OnP0drBw8+ssL+Ok6iCh57KzNfDxtG5vMq1uMeSlqvo6e3u7/Lb3OLFyNScoLOXm66MkaYJWavPAAABcklEQVRo3u3ZV5KDMAwGYBsIkN0YMKbXUNPb3v9w+2w/W8pM4u8CGs8kktBPDOMLhMwKNpoFlgiJajO5ad/vNOq7pD6U6nuGc+JFVC+n4UseyG9ieUpBJEcmFbJePgXhuZZUKEgjCiJKgvcUsp6cguB1KxUSh0vjUO0c2x2FVGjP8oT7tmb+bnmImCiVqmkufrQqzo+BxUQRh2V132p1H9qQGIYBQATjdPrV6ZQfRytT+0JW5ZfO87Xi6+u4CeUelFWF10SOZlHDZ3VnOK8URHqSd4brYlMQ9qWUR/kKNcrXQH7RX0NB2Iv8orboKYhuvsm/uq3rUABRXWXKJD/Uac89rXiXFKPYE5kY8uLpalXPU5kRVRyy1tLsxsKYGMYXgfsfoXUGtF6H1r3R5hHWhMXbGdC2ILS9Dm1TRdu9sb4mDMPQAPVeh3+B3LM8hbqpol2J0e7enx4ZAKYtaPkRZiKmZnwdQMaHklpeW2EyA+ON/gFoxF5srfZBbwAAAABJRU5ErkJggg=="

/***/ }),

/***/ 248:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(250);
	var isArguments = __webpack_require__(249);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 249:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 250:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _warn = __webpack_require__(646);
	
	var _warn2 = _interopRequireDefault(_warn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// https://developers.google.com/tag-manager/quickstart
	
	var Snippets = {
	  tags: function tags(_ref) {
	    var id = _ref.id,
	        events = _ref.events,
	        dataLayer = _ref.dataLayer,
	        dataLayerName = _ref.dataLayerName,
	        preview = _ref.preview,
	        auth = _ref.auth;
	
	    var gtm_auth = '&gtm_auth=' + auth;
	    var gtm_preview = '&gtm_preview=' + preview;
	
	    if (!id) (0, _warn2.default)('GTM Id is required');
	
	    var iframe = '\n      <iframe src="https://www.googletagmanager.com/ns.html?id=' + id + gtm_auth + gtm_preview + '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>';
	
	    var script = '\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\', ' + JSON.stringify(events).slice(1, -1) + '});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';\n        j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl+\'' + gtm_auth + gtm_preview + '&gtm_cookies_win=x\';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,\'script\',\'' + dataLayerName + '\',\'' + id + '\');';
	
	    var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
	
	    return {
	      iframe: iframe,
	      script: script,
	      dataLayerVar: dataLayerVar
	    };
	  },
	  dataLayer: function dataLayer(_dataLayer, dataLayerName) {
	    return '\n      window.' + dataLayerName + ' = window.' + dataLayerName + ' || [];\n      window.' + dataLayerName + '.push(' + JSON.stringify(_dataLayer) + ')';
	  }
	};
	
	module.exports = Snippets;

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _Snippets = __webpack_require__(643);
	
	var _Snippets2 = _interopRequireDefault(_Snippets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TagManager = {
	  dataScript: function dataScript(dataLayer) {
	    var script = document.createElement('script');
	    script.innerHTML = dataLayer;
	    return script;
	  },
	  gtm: function gtm(args) {
	    var snippets = _Snippets2.default.tags(args);
	
	    var noScript = function noScript() {
	      var noscript = document.createElement('noscript');
	      noscript.innerHTML = snippets.iframe;
	      return noscript;
	    };
	
	    var script = function script() {
	      var script = document.createElement('script');
	      script.innerHTML = snippets.script;
	      return script;
	    };
	
	    var dataScript = this.dataScript(snippets.dataLayerVar);
	
	    return {
	      noScript: noScript,
	      script: script,
	      dataScript: dataScript
	    };
	  },
	  initialize: function initialize(_ref) {
	    var gtmId = _ref.gtmId,
	        _ref$events = _ref.events,
	        events = _ref$events === undefined ? {} : _ref$events,
	        dataLayer = _ref.dataLayer,
	        _ref$dataLayerName = _ref.dataLayerName,
	        dataLayerName = _ref$dataLayerName === undefined ? 'dataLayer' : _ref$dataLayerName,
	        _ref$auth = _ref.auth,
	        auth = _ref$auth === undefined ? '' : _ref$auth,
	        _ref$preview = _ref.preview,
	        preview = _ref$preview === undefined ? '' : _ref$preview;
	
	    var gtm = this.gtm({
	      id: gtmId,
	      events: events,
	      dataLayer: dataLayer || undefined,
	      dataLayerName: dataLayerName,
	      auth: auth,
	      preview: preview
	    });
	    if (dataLayer) document.head.appendChild(gtm.dataScript);
	    document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
	    document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
	  },
	  dataLayer: function dataLayer(_ref2) {
	    var _dataLayer = _ref2.dataLayer,
	        _ref2$dataLayerName = _ref2.dataLayerName,
	        dataLayerName = _ref2$dataLayerName === undefined ? 'dataLayer' : _ref2$dataLayerName;
	
	    if (window[dataLayerName]) return window[dataLayerName].push(_dataLayer);
	    var snippets = _Snippets2.default.dataLayer(_dataLayer, dataLayerName);
	    var dataScript = this.dataScript(snippets);
	    document.head.insertBefore(dataScript, document.head.childNodes[0]);
	  }
	};
	
	module.exports = TagManager;

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _TagManager = __webpack_require__(644);
	
	var _TagManager2 = _interopRequireDefault(_TagManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = _TagManager2.default;

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var warn = function warn(s) {
	  console.warn('[react-gtm]', s);
	};
	
	exports.default = warn;

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(649);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(248);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(648);
	
	var _HelmetConstants = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(94);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(257);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(657);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 657:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FooterMenu = __webpack_require__(148);
	
	var _FooterMenu2 = _interopRequireDefault(_FooterMenu);
	
	var _FinePrint = __webpack_require__(147);
	
	var _FinePrint2 = _interopRequireDefault(_FinePrint);
	
	var _footerModule = __webpack_require__(261);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Footer = function Footer() {
	  return _react2.default.createElement(
	    'div',
	    { className: _footerModule2.default.container },
	    _react2.default.createElement(_FooterMenu2.default, null),
	    _react2.default.createElement(_FinePrint2.default, null)
	  );
	};
	
	Footer.displayName = 'Footer';
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _finePrintModule = __webpack_require__(259);
	
	var _finePrintModule2 = _interopRequireDefault(_finePrintModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FinePrint = function FinePrint() {
	  return _react2.default.createElement(
	    'div',
	    { className: _finePrintModule2.default.container },
	    _react2.default.createElement(
	      'p',
	      null,
	      '\xA9 2026 Empire Asset Management Company | 101 Crawfords Corner Road, Suite 3128 Holmdel NJ 07733 | 888-417-8050 | ',
	      _react2.default.createElement(
	        'a',
	        { href: 'mailto:info@empiream.com' },
	        'info@empiream.com'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Member FINRA / SIPC | ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://brokercheck.finra.org/', target: '_blank' },
	        'FINRA\'s BrokerCheck'
	      ),
	      ' | ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/clients-rights' },
	        'Client\'s Rights & Protections'
	      )
	    )
	  );
	};
	
	FinePrint.displayName = 'FinePrint';
	exports.default = FinePrint;
	module.exports = exports['default'];

/***/ }),

/***/ 259:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Footer-components-FinePrint----fine-print-module---container---3QTw9"};

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _footerMenuModule = __webpack_require__(260);
	
	var _footerMenuModule2 = _interopRequireDefault(_footerMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FooterMenu = function FooterMenu() {
	  return _react2.default.createElement(
	    'ul',
	    { className: _footerMenuModule2.default.container },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/about-empire' },
	            'About Empire'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/about-empire#OurPhilosophy' },
	          'Our Philosophy'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/about-empire#RelationshipsMatter' },
	          'Relationships Matter'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/brokerage' },
	            'Brokerage'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/brokerage#TransactionalBrokerage' },
	          'Transactional Brokerage'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/brokerage#ResearchSalesAndTrading' },
	          'Institutional Research, Sales & Trading'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/asset-management' },
	            'Asset Management'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/asset-management#FinancialPlanning' },
	          'Financial Planning'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/investment-banking' },
	            'Investment Banking'
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/investment-banking#CapitalMarkets' },
	          'Capital Markets'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _footerMenuModule2.default.sub, to: '/investment-banking#Syndicate' },
	          'Syndicate'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/login' },
	            'Account Login'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/join-our-team' },
	            'Join Our Team'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h6',
	          null,
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { className: _footerMenuModule2.default.main, to: '/contact-us' },
	            'Contact Us'
	          )
	        )
	      )
	    )
	  );
	};
	
	FooterMenu.displayName = 'FooterMenu';
	exports.default = FooterMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 260:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Footer-components-FooterMenu----footer-menu-module---container---2EJgV","main":"src-components-Footer-components-FooterMenu----footer-menu-module---main---2PCLk","sub":"src-components-Footer-components-FooterMenu----footer-menu-module---sub---QSf2B"};

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Footer----footer-module---container---eLTZU"};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _closeMenuMin = __webpack_require__(675);
	
	var _closeMenuMin2 = _interopRequireDefault(_closeMenuMin);
	
	var _hamburgerMenuMin = __webpack_require__(676);
	
	var _hamburgerMenuMin2 = _interopRequireDefault(_hamburgerMenuMin);
	
	var _Image = __webpack_require__(38);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _hamburgerMenuModule = __webpack_require__(262);
	
	var _hamburgerMenuModule2 = _interopRequireDefault(_hamburgerMenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HamburgerMenu = function (_React$Component) {
	  _inherits(HamburgerMenu, _React$Component);
	
	  function HamburgerMenu(props) {
	    _classCallCheck(this, HamburgerMenu);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isOpen: true
	    };
	
	    _this.toggleMenu = _this.toggleMenu.bind(_this);
	    return _this;
	  }
	
	  HamburgerMenu.prototype.toggleMenu = function toggleMenu() {
	    this.setState(function (prevState) {
	      return {
	        isOpen: !prevState.isOpen
	      };
	    });
	  };
	
	  HamburgerMenu.prototype.render = function render() {
	    var isOpen = this.state.isOpen;
	
	    return isOpen ? _react2.default.createElement(
	      'div',
	      { className: _hamburgerMenuModule2.default.hamburger, onClick: this.toggleMenu },
	      _react2.default.createElement(_Image2.default, { src: _hamburgerMenuMin2.default })
	    ) : _react2.default.createElement(
	      'ul',
	      { className: _hamburgerMenuModule2.default.menuContainer },
	      _react2.default.createElement(
	        'li',
	        { onClick: this.toggleMenu },
	        _react2.default.createElement(_Image2.default, { src: _closeMenuMin2.default })
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about-empire' },
	          'About Empire'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/brokerage' },
	          'Brokerage'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/asset-management' },
	          'Asset Management'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/investment-banking' },
	          'Investment Banking'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/login' },
	          'Account Login'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/join-our-team' },
	          'Join Our Team'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/blog' },
	          'Blog'
	        )
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/contact-us' },
	          'Contact Us'
	        )
	      )
	    );
	  };
	
	  return HamburgerMenu;
	}(_react2.default.Component);
	
	exports.default = HamburgerMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"menuContainer":"src-components-HamburgerMenu----hamburgerMenu-module---menuContainer---3gYo4","hamburger":"src-components-HamburgerMenu----hamburgerMenu-module---hamburger---3crdi"};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _MainLogo = __webpack_require__(151);
	
	var _MainLogo2 = _interopRequireDefault(_MainLogo);
	
	var _Menu = __webpack_require__(153);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _HamburgerMenu = __webpack_require__(149);
	
	var _HamburgerMenu2 = _interopRequireDefault(_HamburgerMenu);
	
	var _headerModule = __webpack_require__(264);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'div',
	    { className: _headerModule2.default.container },
	    _react2.default.createElement(
	      'div',
	      { className: _headerModule2.default.logoAndMenu },
	      _react2.default.createElement(_MainLogo2.default, null),
	      _react2.default.createElement(_Menu2.default, null),
	      _react2.default.createElement(_HamburgerMenu2.default, null)
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _EmpireFull2xMin = __webpack_require__(666);
	
	var _EmpireFull2xMin2 = _interopRequireDefault(_EmpireFull2xMin);
	
	var _mainLogoModule = __webpack_require__(263);
	
	var _mainLogoModule2 = _interopRequireDefault(_mainLogoModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MainLogo = function MainLogo() {
	  return _react2.default.createElement(
	    'div',
	    { className: _mainLogoModule2.default.container },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/' },
	      _react2.default.createElement('img', { src: _EmpireFull2xMin2.default })
	    )
	  );
	};
	
	exports.default = MainLogo;
	module.exports = exports['default'];

/***/ }),

/***/ 263:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header-components-MainLogo----main-logo-module---container---3oK7b"};

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header----header-module---container---2zoPp","logoAndMenu":"src-components-Header----header-module---logoAndMenu---3AYJ5"};

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _menuModule = __webpack_require__(268);
	
	var _menuModule2 = _interopRequireDefault(_menuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu() {
	  return _react2.default.createElement(
	    'ul',
	    { className: _menuModule2.default.container },
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/about-empire' },
	        'About Empire'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/brokerage' },
	        'Brokerage'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/asset-management' },
	        'Asset Management'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/investment-banking' },
	        'Investment Banking'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/login' },
	        'Account Login'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/join-our-team' },
	        'Join Our Team'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/blog' },
	        'Blog'
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      null,
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/contact-us' },
	        'Contact Us'
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Menu----menu-module---container---2PKyH"};

/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(647);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(150);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(146);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _layoutModule = __webpack_require__(269);
	
	var _layoutModule2 = _interopRequireDefault(_layoutModule);
	
	var _reactGtmModule = __webpack_require__(645);
	
	var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	
	  (0, _react.useEffect)(function () {
	    _reactGtmModule2.default.initialize({
	      gtmId: 'GTM-MPBSVMVR'
	    });
	    _reactGtmModule2.default.dataLayer({
	      dataLayer: {
	        event: 'button_click',
	        buttonName: 'Test Event'
	      }
	    });
	  }, []);
	
	  return _react2.default.createElement(
	    'div',
	    { className: _layoutModule2.default.mainContainer },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        title: 'Empire Asset Management'
	      },
	      _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0, shrink-to-fit=no' }),
	      _react2.default.createElement('script', { src: 'https://cdnjs.cloudflare.com/ajax/libs/babel-polyfill/6.26.0/polyfill.min.js' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _layoutModule2.default.mainContent },
	      _react2.default.createElement(_Header2.default, { siteTitle: 'Empire Asset Management' }),
	      children()
	    ),
	    _react2.default.createElement(_Footer2.default, null)
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = Layout;
	module.exports = exports['default'];

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"mainContainer":"src-layouts----layout-module---mainContainer---Y0VZn","mainContent":"src-layouts----layout-module---mainContent---I7c3g"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-5d4a8803be8d7236a8a7.js